import request from '@/api/fetcher/request'

/** 获取活动配置。阿波罗 application => activity */
export function getActConfig (data) {
  return request.post('/api/sdk/act', data)
}

/** 进行兑换会员 */
export function exchangeVip (data) {
  return request.post('/api/v2/exchange/draw', data)
}
